import dayjs from "dayjs";

export   const formatTime = (timeString) => {
    const formattedTime = dayjs(timeString).format("MM/DD [at] hh:mm A");
    return formattedTime;
  };